import React from 'react';
import { Gis } from 'Douleutaras/components/Forms/gis.class';
import { CityBounds, GoogleAutocompleteField } from 'Douleutaras/components/Forms/Fields/GoogleAutocompleteField';

interface AddressAutocompleteFieldProps {
  input: React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
    >;
  bounds?: CityBounds;
  children?: React.ReactElement;
  handleKeyDown?(event): void;
  onChange(gis: Gis): void;
}

/**
 * Address autocomplete backed by Google Maps places. Kept as a thin wrapper so callers
 * depend on a stable `input`/`onChange` contract rather than on the provider directly.
 */
export const AddressAutocompleteField = (props: AddressAutocompleteFieldProps) => {
  return <GoogleAutocompleteField {...props} />;
};
